export default __webpack_public_path__ + "static/media/github.fd80749c.svg";